/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { Query_Keys } from "../../../lib/queryKeys";
import { getBaseQueryKey, mergeQueryKeys } from "../utils/queryKeyHelpers";
import { auditLogRefreshKeys } from "./sharedRefreshKeys";

const baseRevenueCenterKeys = mergeQueryKeys(
  getBaseQueryKey(Query_Keys.revenue_centers)
);

// The Daily Manager Logbook detail resolves its revenue center labels live from this lookup
// table (DocumentBuilder.detail -> center_names), so an import that adds or renames a row
// changes what that page renders. The logbook summary is not listed: it only carries
// restaurant names.
const revenueCenterImportKeys = mergeQueryKeys(
  baseRevenueCenterKeys,
  getBaseQueryKey(Query_Keys.daily_logbook_detail),
  auditLogRefreshKeys
);

export const revenueCenterMutationKeyGroups = {
  fetch: revenueCenterImportKeys,
};
